import { createStore, compose, applyMiddleware } from "redux";
import { reducers } from "../ReduxReducers/index";
import thunk from "redux-thunk";
import { addCustomer } from './../ReduxActions/customerAction';

export const store = createStore(
    reducers,
    compose(applyMiddleware(thunk),window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f)
);

//Initialize
store.dispatch(addCustomer());//برای این که در زمان ایجاد استور یک مشتری خالی ایجاد شود و در کل در اینجا می توانیم دیتا لود کنیم و ما دیتا را آماده داشته باشیم

//subscribe
store.subscribe(() => console.log(store.getState()));
